__webpack_require__.p = "/wp-content/themes/we-theme/public/";